import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Grid, TextField, Button,
  Card, CardContent, CardActions, Switch, IconButton
} from '@mui/material';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const AssociationsManager = () => {
  const [associations, setAssociations] = useState([]);
  const [newName, setNewName] = useState('');
  const [newLogo, setNewLogo] = useState('');
  const [preview, setPreview] = useState('');
  const token = localStorage.getItem('token');

  const apiBase = process.env.REACT_APP_API_BASE_URL;

  const fetchAssociations = () => {
    axios.get(`${apiBase}/api/admin/associations`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setAssociations(res.data))
      .catch((err) => console.error('Fetch error:', err));
  };

  useEffect(() => {
    fetchAssociations();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setNewLogo(reader.result); // base64 string
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleAdd = async () => {
    if (!newName || !newLogo) {
      alert('Name and logo are required.');
      return;
    }

    try {
      await axios.post(
        `${apiBase}/api/admin/associations`,
        { name: newName, logo: newLogo },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      alert('Association added');
      setNewName('');
      setNewLogo('');
      setPreview('');
      fetchAssociations();
    } catch (err) {
      console.error('Post failed:', err);
      alert('Failed to add association');
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${apiBase}/api/admin/associations/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(fetchAssociations)
      .catch((err) => console.error('Delete error:', err));
  };

  const toggleActive = (id, isActive) => {
    axios.put(`${apiBase}/api/admin/associations/${id}`, {
      is_active: !isActive,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(fetchAssociations)
      .catch((err) => console.error('Toggle active error:', err));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Associations</Typography>
      
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <TextField
          label="Name"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          size="small"
        />
        <Button
          variant="contained"
          component="label"
          startIcon={<CloudUploadIcon />}
        >
          Upload Logo
          <input type="file" hidden accept="image/*" onChange={handleFileChange} />
        </Button>
        <Button onClick={handleAdd} variant="contained" color="primary">
          Add Association
        </Button>
      </Box>

      {preview && (
        <Box mb={3}>
          <Typography variant="body2">Preview:</Typography>
          <img src={preview} alt="Preview" style={{ maxHeight: 80 }} />
        </Box>
      )}

      <Grid container spacing={2}>
        {associations.map((assoc) => (
          <Grid item xs={12} sm={6} md={4} key={assoc.id}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold">{assoc.name}</Typography>
                {assoc.logo && (
                  <Box mt={1}>
                    <img
                      src={assoc.logo}
                      alt={assoc.name}
                      style={{ maxWidth: '100%', maxHeight: 100 }}
                    />
                  </Box>
                )}
                <Typography variant="body2" mt={1}>
                  Created by: {assoc.created_by} <br />
                  Modified: {new Date(assoc.modified_date).toLocaleString()}
                </Typography>
              </CardContent>
              <CardActions>
                <Switch
                  checked={assoc.is_active}
                  onChange={() => toggleActive(assoc.id, assoc.is_active)}
                  color="primary"
                />
                <IconButton color="error" onClick={() => handleDelete(assoc.id)}>
                  <DeleteIcon />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AssociationsManager;
